<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import jQuery from "jquery";
import bootstrap from "@/vendor/bootstrap.js";

export default {
  name: "App",
  mounted: async function() {
    let $ = jQuery;
    bootstrap.load_file($);
  },
};
</script>
